import { type ServerResponse, axios } from '~/axios'

import {
  type GetLibraryCodenamesParams,
  type LibraryCodenamesFiltersResponse,
  type LibraryCodenamesResponse,
} from '../types'

export async function getLibraryCodenames(params: GetLibraryCodenamesParams) {
  const query = /* GraphQL */ `
    query getLibraryCodenames(
      $codenameFilters: CodenameFiltersModelInput
      $page: Int
      $pageSize: Int
      $sortBy: String
      $sortDirection: String
    ) {
      getLibraryCodenames(
        codenameFilters: $codenameFilters
        page: $page
        pageSize: $pageSize
        sortBy: $sortBy
        sortDirection: $sortDirection
      ) {
        content {
          id
          codename
          definition
          description
          measurementType
          analysisUnit
          variableType
          stoplightType
          dimensionId
        }
        totalElements
      }
    }
  `

  return await axios<
    ServerResponse<{ getLibraryCodenames: LibraryCodenamesResponse }>
  >({
    method: 'post',
    url: '/graphql',
    data: {
      query,
      variables: {
        codenameFilters: params.codenameFilters,
        page: params.page,
        pageSize: params.pageSize,
        sortBy: params.sortBy,
        sortDirection: params.sortDirection,
      },
    },
  })
}

export async function getLibraryCodenamesFilters() {
  const query = /* GraphQL */ `
    query {
      getLibraryCodenamesFilters
    }
  `

  return await axios<
    ServerResponse<{ getLibraryCodenamesFilters: LibraryCodenamesFiltersResponse }>
  >({
    method: 'post',
    url: '/graphql',
    data: { query },
  })
}
